import { useLocalStorage } from '../../../utils/hooks/useLocalStorage'
import { CostDetailsFilter, GraphGranularity } from '../../../__generated__/graphql'
import { Timeframe, computeTimeframeValues } from './StatsDateRange'

export type PerformanceStatsTimeFilters = {
  startDate: string
  endDate: string
  granularity: GraphGranularity
  timeZone: string
  otherFilters: Record<string, CostDetailsFilter['values']>
}

const defaultTimeframe = Timeframe.THIS_WEEK

export const getDefaultValues: () => PerformanceStatsTimeFilters = () => ({
  startDate: computeTimeframeValues()[defaultTimeframe].startDate,
  endDate: computeTimeframeValues()[defaultTimeframe].endDate,
  granularity: GraphGranularity.Day,
  timeZone: 'Europe/Paris',
  otherFilters: {},
})

export const usePerformanceStatsFiltersStorage = <T extends PerformanceStatsTimeFilters>(
  defaultAdditional?: Partial<T>
): [value: T, setValue: (newValue: T) => void] => {
  return useLocalStorage('performanceStats.filters', { ...getDefaultValues(), ...defaultAdditional } as T, [
    'otherFilters',
  ])
}
